export enum EditorImageState {
  initial = 'initial',
  uploading = 'uploading',
  uploaded = 'uploaded',
  processing = 'processing',
  processed = 'processed',
  error = 'error',
  default = initial,
}
